import { cn } from "@/lib/utils";

interface LimitIndicatorProps {
  used: number;
  total: number;
  nextResetDate?: string;
  className?: string;
}

export const LimitIndicator = ({
  used,
  total,
  nextResetDate,
  className,
}: LimitIndicatorProps) => {
  const remaining = total - used;
  const isExhausted = remaining <= 0;

  return (
    <div className={cn("space-y-2", className)}>
      {isExhausted ? (
        <div className="text-center">
          <p className="text-caption text-muted-foreground">
            Limit erreicht
          </p>
          {nextResetDate && (
            <p className="text-micro mt-1">
              Nächste Freischaltung am {nextResetDate}
            </p>
          )}
        </div>
      ) : (
        <>
          <p className="text-micro text-muted-foreground">
            <span className="text-display text-accent">{remaining}</span>
            <span className="text-micro"> / {total} Anfragen in diesem Monat noch verfügbar</span>
          </p>
        </>
      )}
    </div>
  );
};
